module.exports = __webpack_public_path__ + "static/media/logo-design.20e63322.png";